"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./context"), exports);
tslib_1.__exportStar(require("./authentication"), exports);



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/authentication/index.ts
// module id = 124
// module chunks = 2